// Global broadcaster
const broadcaster = window.broadcaster = {};

// Product variant changed eg. color switcher
const PRODUCT_VARIANT_CHANGED_EVENT_NAME = 'PRODUCT_VARIANT_CHANGED';
broadcaster.triggerProductVariantChanged = ({product_handle,variant_id}) => {
  const e = new Event(PRODUCT_VARIANT_CHANGED_EVENT_NAME);
  e.product_handle = product_handle;
  e.variant_id = variant_id;
  document.dispatchEvent(e);
}
broadcaster.listenToProductVariantChanged = (listener) => {
  document.addEventListener(PRODUCT_VARIANT_CHANGED_EVENT_NAME, listener);
}
